import React from 'react'
import { Progress } from 'antd'
import styles from './UploadControl.module.scss'

function UploadDataProgressBar({ uploadProgress }) {
    return (
        <>
            {uploadProgress ? (
                <Progress
                    percent={!uploadProgress ? 0 : Math.round(uploadProgress.loaded / uploadProgress.total * 100)}
                    size='small'
                    status='normal'
                    className={styles.progress}
                    strokeColor={uploadProgress?.loaded ? '#43E090' : '#80AAFF'}
                />
            ) : null}
        </>
    )
}

export default UploadDataProgressBar
